import { AccountAPIService } from "./account";
import api from "..";

export default new AccountAPIService(api);
